import { useDevice } from '@portalterreno/react-ui/DeviceProvider';
import WhatsAppIcon from '@portalterreno/react-ui-icons/WhatsAppIcon';
import { useTranslation } from 'next-i18next';
import React from 'react';

import useWindowOpen from '../../../../../../hooks/useWindowOpen';
import StyledListItem from '../StyledListItem';
import withShareUrl, { WithShareUrlProps } from './withShareUrl';

export type WhatsappButtonShareProps = Omit<WithShareUrlProps, 'children'>;

const WhatsappButtonShare: React.FC<WhatsappButtonShareProps> = ({
  shareUrl,
  ...rest
}) => {
  const { t } = useTranslation('social');
  const text = `${t('whatsappTextShare')} ${shareUrl}`;
  const { isMobile } = useDevice();

  const url = React.useMemo(() => {
    if (isMobile) {
      return `https://wa.me?text=${text}`;
    }
    return `https://web.whatsapp.com/send?text=${text}`;
  }, [isMobile, text]);

  const handleButtonClick = useWindowOpen(url);
  return (
    <StyledListItem
      leftIcon={<WhatsAppIcon />}
      onClick={handleButtonClick}
      {...rest}
    >
      {t('whatsappButtonShare')}
    </StyledListItem>
  );
};

export default withShareUrl(WhatsappButtonShare, 'whatsapp');
